import React from 'react'
import PropTypes from 'prop-types'
import { STAGING_STATUS, TRADE_BLOTTER_STATUS, WARNING_MESSAGE } from '../../../../utils/constants'
import {
  NewText,
  WarningIconStyle,
  SpaceStyle,
  UnionIconStyle,
  TooltipStyle,
  PendingIconStyle,
  DeleteIconStyle,
  ConversionIconStyle
} from './Status.style'

let flag = true
const Status = ({ data, isDeal, tradeInsideADeal }) => {
  setTimeout(() => {
    flag = false
  }, 1000)

  if (
    (data.status === TRADE_BLOTTER_STATUS.DELETE && isDeal) ||
    (data.is_delete && !isDeal && data.status === TRADE_BLOTTER_STATUS.CONVERSION)
  ) {
    const title =
      data.is_delete && data.status === TRADE_BLOTTER_STATUS.CONVERSION
        ? WARNING_MESSAGE.CONVERSION_TRADE_IS_DELETED
        : WARNING_MESSAGE.DEAL_IS_DELETED
    return (
      <TooltipStyle title={title} placement="top" color="#FF9747">
        <DeleteIconStyle />
      </TooltipStyle>
    )
  }

  if (data.allocation_status === 'Unallocated') {
    return (
      <TooltipStyle title={WARNING_MESSAGE.DEAL_IS_UNALLOCATED} placement="top" color="#FF9747">
        <WarningIconStyle isdeal={String(true)} />
      </TooltipStyle>
    )
  }

  if (data.status === TRADE_BLOTTER_STATUS.WARNING_PRIME_BROKER) {
    return (
      <TooltipStyle title={WARNING_MESSAGE.MISMATCHED_PRIME_BROKER} placement="top" color="#FF9747">
        <WarningIconStyle isdeal={String(true)} />
      </TooltipStyle>
    )
  }

  if (data.status === TRADE_BLOTTER_STATUS.WARNING_SYMBOL) {
    return (
      <TooltipStyle title={WARNING_MESSAGE.MISMATCHED_SYMBOL} placement="top" color="#FF9747">
        <WarningIconStyle isdeal={String(true)} />
      </TooltipStyle>
    )
  }

  if (data.staging_status === STAGING_STATUS.PENDING)
    return (
      <TooltipStyle
        title={isDeal ? WARNING_MESSAGE.DEAL_IS_PENDING : WARNING_MESSAGE.TRADE_IS_PENDING}
        placement="top"
        color="#FF9747"
      >
        <PendingIconStyle isdeal={String(true)} />
      </TooltipStyle>
    )

  // eslint-disable-next-line default-case
  switch (data.status) {
    case TRADE_BLOTTER_STATUS.WARNING_QUANTITY:
      return (
        <TooltipStyle title={WARNING_MESSAGE.MISMATCHED_QUANTITIES} placement="top" color="#FF9747">
          <WarningIconStyle isdeal={String(isDeal)} />
        </TooltipStyle>
      )
    case TRADE_BLOTTER_STATUS.WARNING_EXPIRY:
      return (
        <TooltipStyle
          title={WARNING_MESSAGE.MISMATCHED_SYMBOL_EXPIRY}
          placement="top"
          color="#FF9747"
        >
          <WarningIconStyle isdeal={String(isDeal)} />
        </TooltipStyle>
      )
    case TRADE_BLOTTER_STATUS.WARNING_STRIKE:
      return (
        <TooltipStyle
          title={WARNING_MESSAGE.MISMATCHED_SYMBOL_STRIKE}
          placement="top"
          color="#FF9747"
        >
          <WarningIconStyle isdeal={String(isDeal)} />
        </TooltipStyle>
      )
    case TRADE_BLOTTER_STATUS.WARNING_PUT_CALL:
      return (
        <TooltipStyle
          title={WARNING_MESSAGE.MISMATCHED_SYMBOL_PUT_CALL}
          placement="top"
          color="#FF9747"
        >
          <WarningIconStyle isdeal={String(isDeal)} />
        </TooltipStyle>
      )
    case TRADE_BLOTTER_STATUS.WARNING_CUT:
      return (
        <TooltipStyle title={WARNING_MESSAGE.MISMATCHED_SYMBOL_CUT} placement="top" color="#FF9747">
          <WarningIconStyle isdeal={String(isDeal)} />
        </TooltipStyle>
      )
    case TRADE_BLOTTER_STATUS.CONVERSION:
      return (
        <TooltipStyle title={WARNING_MESSAGE.CONVERSION_TRADE} placement="top" color="#FF9747">
          <ConversionIconStyle />
        </TooltipStyle>
      )
    case TRADE_BLOTTER_STATUS.NEW:
      if (data.staging_status === STAGING_STATUS.STAGED) {
        return (
          <TooltipStyle title={WARNING_MESSAGE.DEAL_IS_STAGED} placement="top" color="#FF9747">
            <WarningIconStyle isdeal={String(true)} />
          </TooltipStyle>
        )
      }

      if (flag) {
        return <NewText isdeal={String(isDeal)}>NEW</NewText>
      } else {
        return <SpaceStyle isdeal={String(isDeal)} />
      }
    case TRADE_BLOTTER_STATUS.UNION:
      return (
        <TooltipStyle title={WARNING_MESSAGE.UNGROUPED_TRADE} placement="top" color="#FFDC51">
          <UnionIconStyle />
        </TooltipStyle>
      )
  }
  if (data.staging_status === STAGING_STATUS.STAGED) {
    return (
      <TooltipStyle title={WARNING_MESSAGE.DEAL_IS_STAGED} placement="top" color="#FF9747">
        <PendingIconStyle isdeal={String(true)} />
      </TooltipStyle>
    )
  }

  if (tradeInsideADeal) {
    return (
      <TooltipStyle title={WARNING_MESSAGE.UNGROUPED_TRADE} placement="top" color="#FFDC51">
        <UnionIconStyle />
      </TooltipStyle>
    )
  }

  return <SpaceStyle isdeal={String(isDeal)} />
}

Status.propTypes = {
  data: PropTypes.object,
  isDeal: PropTypes.bool,
  tradeInsideADeal: PropTypes.bool
}

export default Status
